<template>
  <div class="flex min-h-5 mb-1">
    <span class="text-red-600 text-sm">{{ errMsg }}</span>
  </div>
</template>

<script>
export default {
  name: 'ErrorMessage',
  props: ['errMsg'],
};
</script>

<style lang="sass" scoped>
.min-h-5
  min-height: 1.25rem
</style>
